/* eslint-disable class-methods-use-this */
import React, { Component, Fragment } from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import { Col, Dropdown } from 'antd';

import i18n from 'react-intl-universal';
import styles from './NotebooksWrapper.scss';

// action
import { newNotebook } from '../../actions/NotebooksAction';
import { changeReadMode, changeLocale, changeFontType } from '../../actions/GlobalAction';
import { changeEditorType } from '../../actions/UserAction';

// reducer
import { getState } from '../../reducers/Notebooks/NotebooksReducer';
import { getState as getGlobalState } from '../../reducers/Global/GlobalReducer';
import { getState as getUserState } from '../../reducers/User/UserReducer';

// components
import Icon from '../Icon/Icon';
import NotebookList from '../NotebookList/NotebookList';
// import SidebarAd from '../SidebarAd/SidebarAd';
import NewForm from '../Form/NewForm';
import Message from '../Message';
import AntMenu from '../AntMenu/AntMenu';
import DailyNote from '../DailyNote/DailyNote';

// util
import { getNormalPageUrl } from '../../utils/urlHelper';
import { stopEvent, martinDispatch } from '../../utils/util';
import Modal from '../Modal/Modal';
import verpng from '../../assets/images/verfiy.png';
import ajax from '../../utils/ajax';

// 高阶组件先添加connect，再添加withRouter
@SortableContainer
@withRouter
@connect(
  (state) => {
    const globalState = getGlobalState(state);
    return {
      noteBooks: getState(state),
      readMode: globalState.get('readMode'),
      locale: globalState.get('locale'),
      fontType: globalState.get('fontType'),
      editorType: getUserState(state).getIn(['user', 'preferred_note_type']),
    };
  },
  dispatch => ({
    newNotebook: bookname => martinDispatch(dispatch, newNotebook(bookname)),
    changeReadMode: readMode => dispatch(changeReadMode(readMode)),
    changeLocale: locale => dispatch(changeLocale(locale)),
    changeFontType: fontType => dispatch(changeFontType(fontType)),
    changeEditorType: editorType => dispatch(changeEditorType(editorType)),
  }),
)
export default class NotebooksWrapper extends Component {
  state = {
    helpModalVisible: false,
    showNewBookForm: false,
    isCreatingNb: false,
    showAuthLink: false,
  };

  componentDidMount() {
    this.getshow();
  }

  async getshow() {
    const res = await ajax.getABtest();
    if (res.status >= 200 && res.status < 400) {
      const status = res.data && res.data.h5_real_name_auth_link;
      const show = status === 1;
      this.setState({ showAuthLink: show });
    }
  }

  async getAuthorInfoApi() {
    const res = await ajax.getAuthorInfo();
    if (res.status >= 200 && res.status < 400) {
      const { status, message } = res.data;
      switch (status) {
        case -1:
        case 0:
        case 2:
          window.open('/mobile/author/certification?from=edit', '_blank');
          break;
        default:
          Message.error(message || 'error', { duration: 4000 });
          break;
      }
    }
  }

  newNoteBookBtnClick = (e) => {
    this.setState({ showNewBookForm: true });
  };

  cancelNewBookBtnClick = () => {
    this.setState({ showNewBookForm: false });
  };

  newBookSubmit = (e, value) => {
    const { history } = this.props;
    const bookname = value.trim();
    const { isCreatingNb } = this.state;
    if (!bookname) {
      Message.error(i18n.get('notebooks.new-notebook-empty'));
      return;
    }
    if (isCreatingNb) {
      return;
    }
    this.setState({
      isCreatingNb: true,
    });
    this.props.newNotebook(bookname).then((res) => {
      // 避免push相同的path
      if (+res.id !== +this.props.match.params.nbId) {
        history.push(getNormalPageUrl(res.id));
      }
      this.setState({
        isCreatingNb: false,
      });
    }).catch((error) => {
      this.setState({
        isCreatingNb: false,
      });
    });
    this.setState({ showNewBookForm: false });
    stopEvent(e);
  };

  showUserFeedbackDialog = () => {
    const { Raven } = window;
    if (Raven) {
      if (!Raven.lastEventId()) {
        window.open('/help');
      } else {
        window.Raven.showReportDialog();
      }
    }
  };

  onSettingClick = ({ key }) => {
    switch (key) {
      case 'to-feedback': {
        this.showUserFeedbackDialog();
        break;
      }
      case 'to-recycle': {
        const { history } = this.props;
        history.push('/recycle');
        break;
      }
      case 'change-read-mode': {
        const { readMode } = this.props;
        const newMode = readMode === 'day' ? 'night' : 'day';
        this.props.changeReadMode(newMode);
        break;
      }
      case 'change-font': {
        const { fontType } = this.props;
        const newType = fontType === 'font1' ? 'font2' : 'font1';
        this.props.changeFontType(newType);
        break;
      }
      case 'change-locale': {
        const { locale } = this.props;
        const newLocale = locale === 'zh-CN' ? 'zh-TW' : 'zh-CN';
        this.props.changeLocale(newLocale);
        break;
      }
      case 'markdown': {
        this.props.changeEditorType('markdown');
        break;
      }
      case 'plain': {
        this.props.changeEditorType('plain');
        break;
      }
      case 'to-authorverfiy':
        this.getAuthorInfoApi();
        break;
      default: {
        break;
      }
    }
  };
  onHelpBtnClick = (e) => {
    this.setState({
      helpModalVisible: true,
    });
  }
  onHelpModalCancel = () => {
    this.setState({
      helpModalVisible: false,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  renderHelpModule() {
    return (
      <span
        className={styles['help-wrap']}
        onClick={this.onHelpBtnClick}
      >
        {i18n.get('settings.need-help')}
        <Icon name={'question-circle-o'}/>

      </span>
    );
  }

  render() {
    const { readMode, fontType, locale, editorType } = this.props;
    const { showNewBookForm, isCreatingNb, helpModalVisible, showAuthLink } = this.state;
    const formStyleClasses = classNames({
      [styles.expand]: showNewBookForm,
      [styles.collapse]: !showNewBookForm,
    });
    return (
      <Col className={styles['notebooks-wrapper']} span={4}>
        <div className={styles['to-home']}>
          <a href={window.location.origin}>{i18n.get('notebooks.to-homepage')}</a>
        </div>
        <div className={styles['new-notebook']}>
          <div className={styles['new-notebook--btn']} onClick={this.newNoteBookBtnClick}>
            <Icon name={'plus'}/>
            <span>{isCreatingNb ? i18n.get('notebooks.new-notebook-ing') : i18n.get('notebooks.new-notebook')}</span>
          </div>
          <div className={styles['new-notebook-form']}>
            <NewForm
              className={classNames(formStyleClasses)}
              clearInput={showNewBookForm}
              focus={showNewBookForm}
              placeholder='请输入文集名...'
              onCancelBtnClick={this.cancelNewBookBtnClick}
              onSubmit={this.newBookSubmit}
            />
          </div>
        </div>
        <NotebookList className={styles['notebook-list']}/>
        {/* 设置的占位 */}
        <DailyNote/>
        <div style={{ height: 50 }}/>
        <Col
          className={styles['settings']}
          role="button"
          span={4}
        >
          <Dropdown
            overlay={(
              <AntMenu onClick={this.onSettingClick}>
                {showAuthLink && <AntMenu.Item key="to-authorverfiy"><img src={verpng} width={18}/><span>{i18n.get('settings.author-verfy')}</span></AntMenu.Item>}
                {showAuthLink && <AntMenu.Divider/>}
                <AntMenu.SubMenu
                  className={styles['sub-menu']}
                  title={(
                    <Fragment>
                      <Icon name={'keyboard-o'}/>
                      <span> {i18n.get('settings.editor')}</span>
                    </Fragment>
                  )}
                >
                  <AntMenu.Item key="markdown">
                    {editorType === 'markdown' && <Icon name={'check'}/>}
                    <span> {i18n.get('settings.md-editor')}</span>
                  </AntMenu.Item>
                  <AntMenu.Divider/>
                  <AntMenu.Item key="plain">
                    {editorType === 'plain' && <Icon name={'check'}/>}
                    <span> {i18n.get('settings.rich-editor')}</span>
                  </AntMenu.Item>
                </AntMenu.SubMenu>
                <AntMenu.Divider/>
                <AntMenu.SubMenu
                  className={styles['sub-menu']}
                  title={(
                    <Fragment>
                      <Icon name={'font'}/>
                      <span> {i18n.get('settings.display')}</span>
                    </Fragment>
                  )}
                >
                  <AntMenu.Item key="change-read-mode">
                    {readMode === 'day' ? i18n.get('settings.open-night-mode') : i18n.get('settings.close-night-mode')}
                  </AntMenu.Item>
                  <AntMenu.Divider/>
                  <AntMenu.Item key="change-font">
                    {fontType === 'font1' ? i18n.get('settings.change-to-black') : i18n.get('settings.change-to-song')}
                  </AntMenu.Item>
                  <AntMenu.Divider/>
                  <AntMenu.Item key="change-locale">
                    {locale === 'zh-CN' ? i18n.get('settings.change-to-traditional') : i18n.get('settings.change-to-simple')}
                  </AntMenu.Item>
                </AntMenu.SubMenu>
                <AntMenu.Divider/>
                <AntMenu.Item key="to-recycle">
                  <Icon name={'trash-o'}/>
                  <span> {i18n.get('settings.recycle')}</span>
                </AntMenu.Item>
                <AntMenu.Divider/>
                <AntMenu.Item key="to-feedback">
                  <Icon name={'question-circle-o'}/>
                  <span> {i18n.get('settings.feedback')}</span>
                </AntMenu.Item>
              </AntMenu>
            )}
            trigger={['click']}
          >
            <span>
              <Icon name={'bars'}/>
              <span>{i18n.get('global.setting')}</span>
            </span>
          </Dropdown>
          {
            this.renderHelpModule()
          }
        </Col>
        {
          // portal UI
          <Modal
            visible={helpModalVisible}
            title={i18n.get('settings.common-issue')}
            showFooter={false}
            maskClosable
            isMiddle
            width={320}
            tips={false}
            onCancel={this.onHelpModalCancel}
          >
            <div className={styles['help-modal-body']}>
              如果你在使用编辑器的过程中遇到问题，可以尝试以下方案解决：
              <ul>
                <li>1. Windows用户尽量将浏览器设置为极速模式，不要使用兼容模式写作</li>
                <li>2.推荐使用chrome浏览器，创作体验更加流畅</li>
                <li>3.浏览器插件可能与编辑器功能冲突，可以在使用编辑器时禁用插件</li>
              </ul>
              <div className={styles['confirm-btn']} onClick={this.onHelpModalCancel}>
                我知道了
              </div>
            </div>
          </Modal>
        }
      </Col>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/NotebooksWrapper/NotebooksWrapper.js